import './style.scss';

jQuery(document).ready(function() {
    const $ = jQuery;

let carousel = $('.carousel');
let carouselSlides = $('.carousel__item');
let carouselHeight = 0;
for(let i=0;i<carouselSlides.length;i++){
    if($(carouselSlides[i]).height() > carouselHeight){
        carouselHeight = $(carouselSlides[i]).height()
    }
}
$(carousel).height(carouselHeight);
carouselSlides.hide();
let i = 0;
$(carouselSlides[i]).show();

let carousel_btnPrev = $('.carousel__controls_prev');
let carousel_btnNext = $('.carousel__controls_next');

carousel_btnPrev.click(function(){
    $(carouselSlides[i]).hide();
    if(i > 0){
        i--;
    } else {
        i = carouselSlides.length - 1;
    }
    $(carouselSlides[i]).show();
})

carousel_btnNext.click(function(){
    $(carouselSlides[i]).hide();
    if(i < carouselSlides.length - 1){
        i++;
    } else {
        i = 0;
    }
    $(carouselSlides[i]).show();
})

})